export default "https://cdn-static.gokick.com/assets/c736ccdc0086f37925b8733f1854c980393ad61e/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";